import { renderRequiredRule } from "@/utils/renderRulesForm";
import { useDataFormStore } from "@/stores/form";

export default (cargoInformation) => ({
  typeOfCargo: [renderRequiredRule("Пожалуйста выберите вид")],
  numberOfIdenticalLoads: [renderRequiredRule("Пожалуйста введите количество")],
  cargoVolume: [renderRequiredRule("Пожалуйста введите объём")],
  additionalPackaging: [],
  typeOfPackaging: [
    {
      validator: (rule, value, callback) => {
        if (cargoInformation.additionalPackaging && !value.length) {
          callback(new Error("Пожалуйста выберите тип"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  natureOfCargo: [
    {
      validator: (rule, value, callback) => {
        
        if (!value.id) {
          callback(new Error("Пожалуйста выберите характер груза"));
        }
        if ([23,47,67,68,69].includes(value.id)) {
          const dataForm = useDataFormStore();
          if (dataForm.consigneeInnRadio == true) {
            if(dataForm.other.cargoCost > 10000) {
              callback(new Error("Укажите сумму обьявленной стоимости груза не более 10000 рублей"));
            }
          } else {
            if(dataForm.other.cargoCost > 3000) {
              callback(new Error("Укажите сумму обьявленной стоимости груза не более 3000 рублей"));
            }
          }
          
        }
        callback();
      },
      trigger: "blur",
    },
  ],
});
